import { ConfirmStrings } from './Confirm';
import { NetworkStrings } from './Network';
export const Strings = {
    Network: NetworkStrings,
    Confirm: ConfirmStrings,
};
